// **********************************************************
// Main menu dropdown
// **********************************************************
attachEvent('.menu__item-arrow', 'click', (ev) => {
  if (windowWidth() <= breakpointLg) {
    const arrowParent = ev.target.closest('.menu__item');
    const menuDropdown = arrowParent.querySelectorAll('.menu__dropdown')[0];

    if (arrowParent.classList.contains('is-open-submenu')) {
      slideUp(menuDropdown, 300);
      arrowParent.classList.remove('is-open-submenu');
    } else {
      arrowParent.classList.add('is-open-submenu');
      slideDown(menuDropdown, 300);
    }
  }
});

// const menuLinks = document.querySelectorAll('.has-submenu');
// const toggleMegaMenu = (toggle) => {
//   document.body.classList.toggle('is-open-menu', toggle);
// };
// menuLinks.forEach((el) => {
//   if (windowWidth() > breakpointMd) {
//     el.addEventListener('mouseenter', () => {
//       toggleMegaMenu(true);
//     });

//     el.addEventListener('mouseleave', () => {
//       toggleMegaMenu(false);
//     });
//   }
// });
